// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1KOrd","colMaxWidth":"Table_colMaxWidth__2c73M"};